function delay(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
}

export async function mockUploadVideo(file, onProgress) {
  const steps = [10, 35, 70, 100];
  for (const percent of steps) {
    await delay(200);
    if (onProgress) {
      onProgress({ percent });
    }
  }
  const projectId = `proj-mock-${Date.now()}`;
  return {
    projectId,
    videoId: `video-mock-${Date.now()}`,
    fileName: file.name,
    url: URL.createObjectURL(file),
    sizeBytes: file.size,
    durationSeconds: 600,
    width: 1920,
    height: 1080,
    videoCodec: 'h264',
    hasAudio: true,
  };
}
